import React from 'react';
import { ReviewedByChip } from "~/components/patientReports/PastNotes/ReviewedByChip";
import { ReviewTypeChip } from "~/components/patientReports/PastNotes/ReviewTypeChip";
import Button from "@mui/material/Button";
import { FileOpenOutlined } from "@mui/icons-material";
import dayjs from "dayjs";
import { ReviewDataChip } from "~/components/patientReports/PastNotes/ReviewDataChip";
export const NotesView = (props) => {
    const { note, viewReportClicked } = props;
    console.log('note inside of notes view');
    console.log(note);
    const formattedDate = dayjs(note.created_at).format('M/D/YYYY');
    const inPersonText = note.is_in_person === 1 ? 'In-Person' : 'Remote';
    const otherType = note.is_confirm_analysis === 0 ? note.other_type : null;
    return (React.createElement("div", { style: { height: 250 }, className: 'py-2 px-3 border border-app-gray-line focus:border-y-app-gray-light rounded-md text-sm focus:outline-none focus:ring-2' },
        React.createElement("div", { className: 'overflow-y-auto', style: { height: 200 } }, note.notes ? note.notes : note.glucose_sensor_review),
        React.createElement("div", { className: 'flex justify-between', style: { marginTop: 3 } },
            React.createElement(ReviewedByChip, { name: note.name }),
            React.createElement(ReviewTypeChip, { didTalk: note.did_talk, confirmAnalysis: note.is_confirm_analysis, timeSpent: note.time_spent }),
            otherType ? React.createElement(ReviewDataChip, { dataText: otherType }) : React.createElement(ReviewDataChip, { dataText: inPersonText }),
            React.createElement(ReviewDataChip, { dataText: formattedDate }),
            note.path !== null &&
                React.createElement(Button, { onClick: () => viewReportClicked(note.path), variant: 'contained', size: 'small', startIcon: React.createElement(FileOpenOutlined, null), style: { color: 'white', backgroundColor: '#018FB7', fontWeight: 700 } }, "View Report"))));
};
